import { useContext } from 'react';
import { Link } from 'react-router-dom';
import ThemeContext from '../context/ThemeContext';
import '../styles/Terms.css';

const Privacy = () => {
  const { accentColor } = useContext(ThemeContext);

  return (
   <div>
    <div className="terms-wrapper">
     <div className="terms-card">
     <Link className="termslink" to="/"> | Home | </Link>
     <h1 className="terms"> Refund Policy</h1>
    <p className="termsp">
    EditFarmer – Refund Policy

Effective Date: 2/21/2026

Software Licenses

All purchases of EditFarmer software licenses are final unless otherwise stated at the time of purchase.

Because the Software is delivered digitally and license keys are issued immediately upon purchase, refunds are generally not provided.

Technical Issues

If you experience technical issues preventing installation or activation, please contact:

support@editfarmer.com

We will make reasonable efforts to resolve legitimate technical problems.

Unauthorized Purchases

If you believe your purchase was made fraudulently, contact us immediately.

Changes to Policy

We reserve the right to update this Refund Policy at any time.
    
    </p>
    </div>
    </div>
    </div>
  );
};

export default Privacy;
